import { motion } from "framer-motion";
const AboutMe = () => {
    return(
     <div className="flex flex-col items-center justify-center md:w-full">
        <motion.div
          className="w-full sm:w-full mb-8"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
          // animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
        >
            <div className="p-4">
                 <h3 className="text-5xl sm:text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 text-center bg-clip-text text-transparent">
                    About Us
                </h3>
            </div>
            <div className="flex flex-col md:flex-row  md:items-stretch gap-8 md:gap-10 lg:mt-5">
                {/* {<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d4224.69774837273!2d106.83520425787623!3d-6.171013810760368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sid!2sid!4v1758607703893!5m2!1sid!2sid" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>} */}
                <div className="flex lg:flex-1 items-center justify-center bg-[#fafafa] w-[300px] min-h-[400px] md:min-h-[450px] md:w-[1000px] lg:w-[1000px] mx-auto aspect-video rounded-xl overflow-hidden shadow-lg  outline outline-[#0d3270]">
                    <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.7030697900022!2d106.83185982498996!3d-6.170498793816825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5cbff32cf03%3A0xc0f7ede65818fc6d!2sTaman%20Lapangan%20Banteng!5e0!3m2!1sid!2sid!4v1758621286359!5m2!1sid!2sid"
                    className="w-full h-full border-0"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
                <div className="w-full lg:w-1/4 bg-[#0d3270] p-4 gap-4 rounded-3xl overflow-hidden shadow-lg flex flex-col items-center justify-center text-white">
                    <div className="flex flex-col p-2 text-xs md:text-sm font-montserrat font-semibold">
                        <label>Location </label>
                        <label> Jakarta, Indonesia</label>
                    </div>
                    {/* <div className="flex flex-col p-2 text-xs md:text-sm font-montserrat font-semibold">
                        <label>Location </label>
                        <label> Jakarta, Indonesia</label>
                    </div> */}
                    <div className="flex flex-col p-2 text-xs md:text-sm font-montserrat font-semibold">
                        <label>Email </label>
                        {/* <label>: </label> */}
                        <label> 
                            <a 
                            href="mailto:nurhadinvirianto@gmail.com"  
                            className="underline hover:text-blue-300 transition">
                            nurhadinvrianto@gmail.com
                            </a>
                        </label>
                    </div>
                    <div className="flex flex-col p-2 text-xs md:text-sm font-montserrat font-semibold">
                        <label>Linkedln </label>
                        {/* <label>: </label> */}
                        <label><a 
                                href="https://www.linkedin.com/in/nurhadi-novrianto-01b53a1b9" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="underline hover:text-blue-300 transition"
                            > nurhadi-novrianto-01b53a1b9</a>
                        </label>
                    </div>
                    <div className="h-10"></div>
                </div>
            </div>
        </motion.div>
     </div>

    )
}
export default AboutMe;